<script>
/**
 * Imports
 */
import { h, defineComponent } from "vue";
import InlineSvg from "vue-inline-svg";

// For render function components, we'll keep using defineComponent
export default defineComponent({
  name: "IconComponent",
  /**
   * Props & Emits
   */
  props: {
    name: String,
    category: {
      type: String,
      default: "lucide",
    },
    noFill: Boolean,
    size: {
      type: String,
      default: "md",
      validator: (v) => ["xs", "sm", "md", "lg", "xl"].includes(v),
    },
  },
  setup(props) {
    /**
     * Variables
     */
    let error = false;
    let template = false;

    /**
     * Methods & Render function
     */
    if (!error) {
      template = h(
        "figure",
        {
          class: `icon ${props.category}-${props.name}-icon ${props.noFill ? "no-fill" : ""} icon--${
            props.size
          }`,
        },
        h(InlineSvg, {
          src: `/assets/svg/${props.category}/${props.name}.svg`,
          onError: () => {
            error = true;
          },
        })
      );
    }

    // Return render function
    return () => template;
  },
});
</script>

<style lang="stylus">
.icon {
  svg {
    width 100%
    height 100%
    pointer-events none
  }

  &--xs {
    width 16px
    height 16px
  }

  &--sm {
    width 20px
    height 20px
  }

  &--md {
    width 24px
    height 24px
  }

  &--lg {
    width 28px
    height 28px
  }

  &--xl {
    width 32px
    height 32px
  }
}
</style>
